import React, { useState } from 'react'
import { useCreateCategory } from 'hooks/category/useCreateCategory'
import { CCol, CButton, CImage } from '@coreui/react'
import FormikControl from 'components/FormikControl'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import image from 'assets/images/add.png'

const AddCategory = () => {
  const [initialValues, setInitialValues] = useState({
    code: '',
    title: '',
    image_id: '',
    priority: 1,
  })

  const { mutate: addCategory } = useCreateCategory()

  const handleFormSubmit = (data) => {
    console.log(data)
    let bodyFormData = new FormData()
    bodyFormData.append('code', data.code)
    bodyFormData.append('title', data.title)
    bodyFormData.append('image_id', data.image_id)
    bodyFormData.append('priority', data.priority)
    addCategory(bodyFormData)
  }

  const validationSchema = Yup.object({
    code: Yup.string(),
    title: Yup.string(),
    image_id: Yup.string().required('Required'),
    priority: Yup.string().required('Required'),
  })

  // TODO: Store the advertisement errors into a state, then render the appropriate error message on the applicable input fields. The prop documentation of coreUI is given here: https://coreui.io/react/docs/4.0/forms/validation/. Follow it.
  return (
    <div>
      <div className="body flex-grow-1 px-3 py-3 border mt-3 rounded">
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={(values) => {
            handleFormSubmit(values)
          }}
        >
          {({ setFieldValue }) => (
            <Form autoComplete="off" className="row g-3">
              <CCol md={12} style={{ position: 'relative' }}>
                <CImage
                  rounded
                  thumbnail
                  width={120}
                  height={120}
                  src={
                    (initialValues.image_id && URL.createObjectURL(initialValues.image_id)) || image
                  }
                />
                <input
                  type="file"
                  placeholder="Image"
                  label="Image"
                  name="image_id"
                  style={{
                    opacity: 0,
                    left: 0,
                    position: 'absolute',
                    height: 120,
                    width: 120,
                    zIndex: 9999,
                  }}
                  onChange={(event) => {
                    setInitialValues({ ...initialValues, image_id: event.currentTarget.files[0] })
                    setFieldValue('image_id', event.currentTarget.files[0])
                  }}
                />
              </CCol>
              <FormikControl
                control="input"
                type="text"
                placeholder="Code"
                label="Code"
                name="code"
              />
              <FormikControl
                control="input"
                type="text"
                placeholder="Title"
                label="Title"
                name="title"
              />
              <FormikControl
                control="select"
                placeholder="Priority"
                type="number"
                label="Priority"
                name="priority"
                options={[
                  { key: 'Most', value: 1 },
                  { key: 'Least', value: 0 },
                ]}
              />
              <CCol xs={12}>
                <CButton type="submit" className="mt-2">
                  Add Category
                </CButton>
              </CCol>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default AddCategory
